export const getMediaShareLinks = (state, mediaId) => state.shareLinks[mediaId];